import React from 'react'
import useDocumentTitle from '../functions/useDocumentTitle'
import Breadcrumb from './components/Breadcrumb'
import Pagecontainer from './Pagecontainer'

const Services = () => {
    useDocumentTitle('Services - Aabaddha SACCOS Ltd.')
    return (
        <>
            <Breadcrumb root='Home' current='Services' />
            <Pagecontainer>
                Services
            </Pagecontainer>
        </>
    )
}

export default Services